export default [
  {
    path: '/department',
    name: 'list-department',
    component: () => import('@/views/department/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.department',
      resource: 'manage-department',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.list_department',
          active: true,
        },
      ],
    },
  },
  {
    path: '/department/create',
    name: 'create-department',
    component: () => import('@/views/department/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.department',
      navActiveLink: 'list-department',
      resource: 'manage-department',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.list_department',
          to: { name: 'list-department' },
        },
        {
          text: 'breadcrumb.create_department',
          active: true,
        },
      ],
    },
  },
  {
    path: '/department/:id/update',
    name: 'update-department',
    component: () => import('@/views/department/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.department',
      navActiveLink: 'list-department',
      resource: 'manage-department',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.list_department',
          to: { name: 'list-department' },
        },
        {
          text: 'breadcrumb.update_department',
          active: true,
        },
      ],
    },
  },
  {
    path: '/department/:departmentId/team',
    name: 'list-team',
    component: () => import('@/views/department/Team.vue'),
    meta: {
      pageTitle: 'breadcrumb.department',
      resource: 'manage-department',
      navActiveLink: 'list-department',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.list_department',
          to: { name: 'list-department' },
        },
        {
          text: 'breadcrumb.team',
          active: true,
        },
      ],
    },
  },
  {
    path: '/department/:departmentId/:departmentId/:teamId/employee',
    name: 'list-team-employee',
    component: () => import('@/views/department/Employee.vue'),
    meta: {
      pageTitle: 'breadcrumb.department',
      resource: 'manage-department',
      navActiveLink: 'list-department',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.list_department',
          to: { name: 'list-department' },
        },
      ],
    },
  },
  // {
  //   path: '/department/:departmentId/employee/create',
  //   name: 'create-employee',
  //   component: () => import('@/views/employee/Create.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     navActiveLink: 'list-department',
  //     resource: 'manage-department',
  //     action: 'create',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.list_employee',
  //         to: { name: 'list-employee' },
  //       },
  //       {
  //         text: 'breadcrumb.create_employee',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/department/:departmentId/employee/:id/update',
  //   name: 'update-employee',
  //   component: () => import('@/views/employee/Update.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     navActiveLink: 'list-department',
  //     resource: 'manage-department',
  //     action: 'update',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.list_employee',
  //         to: { name: 'list-employee' },
  //       },
  //       {
  //         text: 'breadcrumb.update_employee',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/department/:departmentId/service-system',
  //   name: 'list-department-service-system',
  //   component: () => import('@/views/department/serviceSystem/List.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     resource: 'manage-service-system',
  //     navActiveLink: 'list-department',
  //     action: 'read',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  //     resource: 'manage-service-system',
  //     navActiveLink: 'list-department',
  //     action: 'update',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         to: { name: 'list-department-service-system' },
  //       },
  //       {
  //         text: 'breadcrumb.updateServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/department/:departmentId/service-system/:id/detail',
  //   name: 'detail-department-service-system',
  //   component: () => import('@/views/department/serviceSystem/Detail.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     resource: 'manage-service-system',
  //     navActiveLink: 'list-department',
  //     action: 'view',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.listServiceSystem',
  //         to: { name: 'list-department-service-system' },
  //       },
  //       {
  //         text: 'breadcrumb.detailServiceSystem',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
]
